module.exports = __webpack_public_path__ + "mo/img/board_00.33d5b018.png";